module.exports = __webpack_public_path__ + "cu.7797b415.svg";